module.exports = __webpack_public_path__ + "static/img/om.1798270b.svg";